module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/458e9061efe7fcdc107bac0c7b823cc5.png";